import {
  useWSModal,
  WSActions,
  WSAlert,
  WSButton,
  WSElement
} from "@wingspanhq/fe-component-library";
import { Engagement } from "@wingspanhq/wingspan-api-sdk";
import React from "react";
import { ActionEngagementDetails } from "../components/ActionEngagementDetails";
import { useHistory } from "react-router-dom";
import { PAYEES_ALL_PATH } from "../../Payees/utils";

export interface ArchiveNotAllowedModalProps {
  engagement: Engagement;
  onClose: () => void;
}

export const ArchiveNotAllowedModal: React.FC<ArchiveNotAllowedModalProps> = ({
  engagement,
  onClose
}) => {
  const history = useHistory();

  return (
    <>
      <ActionEngagementDetails engagement={engagement} />

      <WSAlert
        my="2XL"
        theme="warning"
        icon="alert"
        size="M"
        title="Engagement cannot be archived when:"
      >
        <WSElement as="ul" ml="L">
          <li>Active assignments associated with this engagement exist.</li>
        </WSElement>
        To archive the engagement, assignments must be archived or removed from
        this engagement.
        <WSElement>
          <WSButton.Link
            rightIcon="chevron-right"
            onClick={() => {
              history.push(
                `${PAYEES_ALL_PATH}?engagementId=${engagement.id ?? ""}`
              );
            }}
          >
            View contractors
          </WSButton.Link>
        </WSElement>
      </WSAlert>

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Done",
            onClick: onClose,
            kind: "Secondary"
          }
        ]}
      />
    </>
  );
};

export const useArchiveNotAllowedModal = () => {
  return useWSModal(ArchiveNotAllowedModal, {
    title: "Archive engagement",
    size: "M"
  });
};
